<template>
  <div>
    <slot :result="result" :error="error" :loading="loading"></slot>
  </div>
</template>

<script>
import EnvProvider from "jvjr-docker-env";
export default {
  props: {
    baseUrl: {
      type: String,
      default: () => EnvProvider.value("API_URL"),
      required: true
    },
    method: {
      type: String,
      default: () => "GET"
    },
    token: {
      type: String
    },
    body: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      result: null,
      error: null,
      loading: false
    };
  },
  created() {
    this.makeRequest();
  },
  methods: {
    async makeRequest() {
      try {
        this.loading = true;
        this.error = null;
        const result = await fetch(this.baseUrl, {
          method: this.method,
          headers: {
            "Content-Type": "application/json",
            "request-origin": "sgp-front",
            "x-auth-token": this.token,
            "accept": "*/*"
          },
          body: JSON.stringify(this.body)
        });
        this.result = await result.json();
        if (
          this.baseUrl.includes("operacao") &&
          !this.baseUrl.includes("byState") &&
          !this.baseUrl.includes("grupo_operacao") &&
          ((this.body && this.body.page === 0) ||
            this.baseUrl.includes("page=0"))
        ) {
          this.result.content.unshift({
            id: 0,
            cdCliente: 0,
            cdOperacao: -1,
            descOperacao: this.$t("filters.notDefined"),
            vlGrafico: "",
            cdProcesso: 0,
            cdIdEstado: 0
          });
          this.result.totalElements += 1;
        }
      } catch (error) {
        this.error = error;
        console.error(error);
      } finally {
        this.loading = false;
        this.$emit("makeRequestFinally");
      }
    }
  },
  watch: {
    baseUrl() {
      this.makeRequest();
    },
    body() {
      this.makeRequest();
    }
  }
};
</script>
